export default __webpack_public_path__ + "static/media/miscellaneous25.c7f3c074.png";